import PromocodesAdminService from '@/api/PromocodesAdminService.js'
import Vue from 'vue'
export const promocodesAdminModule = {
  namespaced: true,
  state: () => ({
    promocodesAdminData: [],
    promocodesAdminLoadStatus: 'request',
    paginationPromocodesStateParams: {
      count: 0,
      limit: 5,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationPromocodesStateParams.total /
        state.paginationPromocodesStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.promocodesAdminData = [...data]
    },
    create(state, data) {
      state.promocodesAdminData.unshift(data[0])
    },
    edit_multiple(state, data) {
      let indexed = state.promocodesAdminData.findIndex(
        (x) => x.promocodes__id == data.id
      )
      Object.assign(state.promocodesAdminData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.promocodesAdminData.findIndex(
        (x) => x.promocodes__id == id
      )
      state.promocodesAdminData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationPromocodesStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.promocodesAdminLoadStatus = 'request'
    },
    load_success(state) {
      state.promocodesAdminLoadStatus = 'success'
    },
    load_error(state) {
      state.promocodesAdminLoadStatus = 'error'
    }
  },
  actions: {
    getPromocodesAdminAll({ commit }, params) {
      commit('load_request')

      PromocodesAdminService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createPromocodesAdminData({ commit }, createData) {
      PromocodesAdminService.create(createData)
        .then((data) => {
          commit('create', data.data.data.rows)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editPromocodesAdminMultiple({ commit }, { id, dataEdit }) {
      PromocodesAdminService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deletePromocodesAdminData({ commit }, id) {
      // commit("load_request");
      PromocodesAdminService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
